var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"rules":_vm.rules,"color":"primary","flat":"","items":_vm.$store.state.clients.root.data,"loading":_vm.$store.state.clients.status === 'fetching',"label":"Cliente","item-text":"name","item-value":"company_uid","value":parseInt(_vm.$store.state.openUser.details.company_uid),"disabled":_vm.$store.state.session.data.role !== 'coverme_super_admin'},on:{"input":function($event){return _vm.$store.commit('openUser/mutate', {
      property: 'details.company_uid',
      with: $event
    })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }